import logo1x from '../../assets/logo.png'
import logo2x from '../../assets/logo@2x.png'
import logo3x from '../../assets/logo@3x.png'
import loaderLogo1x from '../../assets/loaderLogo.png'
import loaderLogo2x from '../../assets/loaderLogo@2x.png'
import loaderLogo3x from '../../assets/loaderLogo@3x.png'

interface LogoProps {
  variant?: 'full' | 'icon'
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Logo({ variant = 'full', size = 'md', className = '' }: LogoProps) {
  const sizes = {
    sm: { width: 80, height: 32 },
    md: { width: 120, height: 48 },
    lg: { width: 160, height: 64 },
  }

  const iconSizes = {
    sm: { width: 24, height: 24 },
    md: { width: 32, height: 32 },
    lg: { width: 48, height: 48 },
  }

  const currentSize = variant === 'full' ? sizes[size] : iconSizes[size]

  if (variant === 'icon') {
    return (
      <img
        src={loaderLogo1x}
        srcSet={`${loaderLogo1x} 1x, ${loaderLogo2x} 2x, ${loaderLogo3x} 3x`}
        alt="Finch"
        width={currentSize.width}
        height={currentSize.height}
        className={className}
      />
    )
  }

  return (
    <img
      src={logo1x}
      srcSet={`${logo1x} 1x, ${logo2x} 2x, ${logo3x} 3x`}
      alt="Finch Pay"
      width={currentSize.width}
      height={currentSize.height}
      className={className}
    />
  )
}
